

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RouterModule} from "@angular/router";
import {MatTreeModule} from "@angular/material/tree";
import {TranslateModule} from "@ngx-translate/core";
import {SupplierOrderComponent} from "./supplierOrder.component";
import {SupplierOrderFormComponent} from "./supplierOrderForm.component";
import {SupplierOrderMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {MatTableModule} from "@angular/material/table";
import {AlertService} from "../services";
import {SellingNavbarComponent} from "./navbar/sellingNavbar.component";
import {SupplierOrderDetailsComponent} from "./supplierOrderDetails.component";
import {SecurityModule} from "../security/security.module";

@NgModule({
    declarations: [
        SupplierOrderComponent,
        SupplierOrderFormComponent,
        SupplierOrderMainSidebarComponent,
        SellingNavbarComponent,
        SupplierOrderDetailsComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatToolbarModule,
        MatTreeModule,
        TranslateModule,
        MatTableModule,
        SecurityModule,
    ],
    providers: [AlertService,],
    exports: [
        SellingNavbarComponent
    ],
    bootstrap: [
        SupplierOrderComponent,
        SupplierOrderFormComponent,
        SupplierOrderDetailsComponent,
    ]
})
export class SupplierOrderModule { }
